module.exports = __webpack_public_path__ + "static/img/we_heart_design_print.724f59d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/we_heart_design_print.png
// module id = faPJ
// module chunks = 1